import Service from "../../AuthService";
const FactorialMaterial = {
    getFactorialMaterial(page) {
        return Service.get("/factorial-material?page="+page);
    },
    showFactorialMaterial(id) {
        return Service.get("/factorial-material/" + id);
    },
    updateFactorialMaterial(id, data) {
        return Service.put("/factorial-material/" + id, data);
    },
    createFactorialMaterial(data) {
        return Service.post("/factorial-material", data);
    },
    deleteFactorialMaterial(id) {
        return Service.delete("/factorial-material/" + id);
    },
    searchFactorialMaterial(data){
        return Service.post('/search-factorial-material',data);
    },
};
export default FactorialMaterial;
